package songwritersnotebook.app.utils

import kotlinx.browser.window

actual object PlatformToast {
    actual fun show(message: String) {
        // We use window.alert as a simple implementation for now.
        // In a more polished version, we could use a custom Compose-based Snackbar.
        window.alert(message)
    }
}
